export default "__VITE_ASSET__BVOkzTiT__"